import request from '../utils/request'
//获取字典列表
export function fetchSysDicList(sys, catalogName, select = "Title,Name,Order,ParentID,ID") {
  return request({
    url: `/Common.SysDicData/QueryForRunTime`,
    method: 'POST',
    data: {
      sys,
      catalogName,
      select,
    }
  })
}

// 批量获取字典数据
export function fetchBatchSysDicList(r) {
  return request({
    url: `/Common.SysDicData/GetMany`,
    method: 'POST',
    data: {
      request: r
    }
  })
}

//获取聊天列表
export function fetchBgUserLists(where) {
  return request({
    url: `/BasicData.BgUser/Query`,
    method: 'POST',
    data: {
      where,
      "order": "Name asc",
      "select": "Name,OrgStructure.Title,ID",
      "top": 200,
    }
  })
}

//获取所有客户集合
export function fetchAllPeople(userIds) {
  return request({
    url: `/BasicData.UserLogin/GetUsers`,
    method: 'POST',
    data: {
      userIds
    }
  })
}


//获取所有银行
export function fetchAllBank(BankType = 1) {
  return request({
    url: `/BasicData.BankBranch/Query`,
    method: 'POST',
    data: {
      order: "ID desc",
      where: `BankType = ${BankType}`,
      select: 'ID,Name,InstitutionNumber,Address,CustomerManager,ContactWay,InnerEmail',
      option: 0
    }
  })
}

// 导出公共方法
export function exportFileCommon(url, params) {
  return request({
    url,
    responseType: 'blob',
    method: 'POST',
    data: params,
  })
}

//获取可获取的权限
export function getActionPermit(actionTagGroup) {
  return request({
    url: `/Common.Permit/GetActionPermit`,
    method: 'POST',
    data: {
      actionTagGroup
    }
  })
}

// 获取出函机构
export function getAllGuaOrg(code) {
  return request({
    url: `/BasicData.GuaOrg/Query`,
    method: 'POST',
    data: {
      order: 'Sequence asc',
      where: code ? `Code = '${code}'` : `1=1`
    }
  })
}

//获取所有业务员
export function fetchBusiList() {
  return request({
    url: `/BasicData.BgUser/GetBgUsers`,
    method: 'POST',
    data: {
      type: 1
    }
  })
}

//获取所有银行列表包含已删除的
export function getAllBank() {
  return request({
    url: `/BasicData.BankBranch/Query`,
    method: 'POST',
    data: {
      order: "ID desc",
      where: '',
      select: 'ID,Name',
      option: 1
    }
  })
}

//根据类型获取待上传格式ID并缓存
export function fetchAuditFormatId() {
  return request({
    url: `/BasicData.ProjectFormat/GetPendingUploadFormat`,
    method: 'POST',
    data: {}
  })
}

